/* Publish by EComposer at 2026-10-07 16:21:49*/
;try{
 (function () {
  'use strict';
  if (window.__astroyaFjxBoot) { return; }

  var API = 'https://n8n.astroya.fr/webhook/flamme-jumelle';
  var TOKEN_KEY = 'astroya_fj_token';
  var EMAIL_KEY = 'astroya_fj_email';
  var COOKIE_DAYS = 400;

  /* ---------- Donnees ---------- */

  var QUESTIONS = [ /* textes seulement, le calcul est dans n8n */
    { q: "O\u00f9 en est ta relation avec cette personne aujourd'hui ?", o: [
      ["Je ne l'ai pas encore rencontr\u00e9e, mais je sens qu'elle existe"],
      ["On vient de se rencontrer, tout est intense et \u00e9vident"],
      ["On est ensemble, mais les disputes s'encha\u00eenent"],
      ["Nous sommes s\u00e9par\u00e9s ou \u00e0 distance"]] },
    { q: "Quand tu penses \u00e0 cette personne, que ressens-tu d'abord ?", o: [
      ["Une impression de d\u00e9j\u00e0-vu, comme si je la connaissais depuis toujours"],
      ["Une joie euphorique, presque une ivresse"],
      ["De l'angoisse : j'ai peur de la perdre"],
      ["Une paix nouvelle, m\u00eame sans elle"]] },
    { q: "Qui fait le premier pas pour se parler ?", o: [
      ["Toujours moi, l'autre s'\u00e9loigne"],
      ["Personne : le silence s'est install\u00e9"],
      ["Les deux, naturellement"],
      ["Je n'ose pas encore"]] },
    { q: "Quelle phrase te ressemble le plus en ce moment ?", o: [
      ["Je vois ses initiales, des heures miroirs, des signes partout"],
      ["Cette relation r\u00e9veille mes blessures les plus anciennes"],
      ["Je me concentre enfin sur moi et sur ma propre vie"],
      ["Je me sens disponible pour aimer, sans savoir qui"]] },
    { q: "Comment r\u00e9agis-tu face \u00e0 vos conflits ?", o: [
      ["Je fuis ou je me ferme"],
      ["Je cherche \u00e0 tout r\u00e9parer, quitte \u00e0 m'oublier"],
      ["On en parle et on grandit ensemble"],
      ["Il n'y en a pas encore, tout est fluide"]] },
    { q: "Quel est ton rapport aux signes de l'univers ?", o: [
      ["Ils m'ont guid\u00e9e vers cette rencontre"],
      ["Je les guette chaque jour pour savoir si l'autre va revenir"],
      ["Je les accueille sans en d\u00e9pendre"],
      ["Je commence \u00e0 peine \u00e0 les remarquer"]] },
    { q: "Que souhaites-tu le plus aujourd'hui ?", o: [
      ["Rencontrer enfin cette \u00e2me"],
      ["Que la passion du d\u00e9but dure toujours"],
      ["Comprendre pourquoi \u00e7a fait si mal"],
      ["Vivre une union apais\u00e9e et construite"]] }
  ];

  var HOURS = [
    ["00h00", "Un cycle de ta connexion se referme pour laisser place \u00e0 un d\u00e9part neuf. Laisse le pass\u00e9 derri\u00e8re toi pour accueillir ce qui vient."],
    ["01h01", "Ta flamme pense \u00e0 toi en ce moment. Votre lien reste actif, m\u00eame dans le silence."],
    ["02h02", "Un \u00e9quilibre se cherche entre vous. La douceur d\u00e9nouera ce que la force bloque."],
    ["03h03", "Tes guides confirment que tu avances sur le bon chemin, m\u00eame s'il te para\u00eet sinueux."],
    ["04h04", "Tu es soutenue pendant cette \u00e9tape difficile. Construis d'abord ta propre stabilit\u00e9."],
    ["05h05", "Un changement se pr\u00e9pare dans votre histoire. Une v\u00e9rit\u00e9 va \u00e9clairer la situation."],
    ["06h06", "L'harmonie commence en toi. Prends soin de toi comme tu prendrais soin de l'autre."],
    ["07h07", "Ton \u00e9veil spirituel s'acc\u00e9l\u00e8re. Ce que tu vis a un sens plus profond qu'il n'y para\u00eet."],
    ["08h08", "Une \u00e9nergie d'abondance circule. L'amour que tu donnes te revient sous une autre forme."],
    ["09h09", "Le pardon lib\u00e8re votre lien. L\u00e2che une rancune envers l'autre, ou envers toi."],
    ["10h10", "Une porte s'ouvre. Un nouveau chapitre se pr\u00e9pare dans ta vie amoureuse."],
    ["11h11", "Le grand portail des flammes jumelles : la pens\u00e9e que tu as en voyant cette heure compte. Formule une intention claire pour ta connexion."],
    ["12h12", "Alignement : ton \u00e2me et celle de ta flamme vibrent sur la m\u00eame fr\u00e9quence aujourd'hui."],
    ["13h13", "Reste lucide : distingue la vraie connexion d'un attachement qui te fait souffrir."],
    ["14h14", "La patience porte ses fruits. L'\u00e9preuve que tu traverses te fait grandir."],
    ["15h15", "Une passion intense se r\u00e9veille. Vis-la sans te perdre toi-m\u00eame."],
    ["16h16", "Un retour au calme se dessine dans votre relation. L'harmonie revient au foyer."],
    ["17h17", "Tu sors d'une p\u00e9riode sombre : la lumi\u00e8re revient dans ta connexion."],
    ["18h18", "Une union se renforce ou se pr\u00e9pare. Votre lien gagne en profondeur."],
    ["19h19", "Un cycle s'accomplit. Tu r\u00e9coltes le fruit de ton travail int\u00e9rieur."],
    ["20h20", "Une tension demande ta douceur. Choisis l'\u00e9coute plut\u00f4t que la r\u00e9action."],
    ["21h21", "Une nouvelle sentimentale approche. Ouvre ton c\u0153ur \u00e0 ce qui vient."],
    ["22h22", "Le nombre ma\u00eetre de la construction : votre lien peut devenir durable si tu restes fid\u00e8le \u00e0 toi."],
    ["23h23", "Tes guides veillent sur toi. Tu n'es pas seule, m\u00eame quand la distance p\u00e8se."]
  ];

  /* ---------- Utilitaires ---------- */
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { } }
  function ckGet(k) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].replace(/^\s+/, '');
        if (p.indexOf(k + '=') === 0) { return decodeURIComponent(p.substring(k.length + 1)); }
      }
    } catch (e) { }
    return null;
  }
  function ckSet(k, v) {
    try {
      var dom = /(^|\.)astroya\.fr$/i.test(window.location.hostname) ? ';domain=.astroya.fr' : '';
      var sec = window.location.protocol === 'https:' ? ';Secure' : '';
      document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=' + (COOKIE_DAYS * 86400) + dom + ';SameSite=Lax' + sec;
    } catch (e) { }
  }
  function ckDel(k) {
    try {
      var dom = /(^|\.)astroya\.fr$/i.test(window.location.hostname) ? ';domain=.astroya.fr' : '';
      document.cookie = k + '=;path=/;max-age=0' + dom;
    } catch (e) { }
  }
  function getToken() { return lsGet(TOKEN_KEY) || ckGet(TOKEN_KEY) || ''; }
  function setToken(t) { lsSet(TOKEN_KEY, t); ckSet(TOKEN_KEY, t); }
  function clearToken() { try { window.localStorage.removeItem(TOKEN_KEY); } catch (e) { } ckDel(TOKEN_KEY); }
  function isUnlocked() { return !!getToken(); }

  /* ---------- Appel du webhook n8n ---------- */
  function api(payload, cb) {
    payload.token = getToken();
    payload.page = 'flamme-jumelle';
    if (window.__fjxMock) { window.__fjxMock(payload, cb); return; }
    try {
      var x = new XMLHttpRequest();
      x.open('POST', API, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.timeout = 15000;
      x.onreadystatechange = function () {
        if (x.readyState !== 4) { return; }
        if (x.status >= 200 && x.status < 300) {
          var d = null;
          try { d = JSON.parse(x.responseText); } catch (e) { d = null; }
          if (!d || d.ok !== true) { try { console.warn('[Astroya flamme jumelle] reponse n8n : ' + String(x.responseText || '(vide)').substring(0, 300)); } catch (e5) { } }
          cb(d && typeof d === 'object' ? d : { ok: false });
        } else {
          try { console.warn('[Astroya flamme jumelle] webhook HTTP ' + x.status + ' : ' + String(x.responseText || '').substring(0, 300)); } catch (e2) { }
          cb({ ok: false });
        }
      };
      x.onerror = function () { try { console.warn('[Astroya flamme jumelle] webhook injoignable ou bloque par CORS : ' + API); } catch (e3) { } cb({ ok: false }); };
      x.ontimeout = function () { try { console.warn('[Astroya flamme jumelle] webhook : delai depasse'); } catch (e4) { } cb({ ok: false }); };
      x.send(JSON.stringify(payload));
    } catch (er) { cb({ ok: false }); }
  }
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { }

  /* ---------- Canvas : deux flammes en infini ---------- */
  function initCanvas() {
    var cv = $('fjx-canvas');
    if (!cv || !cv.getContext) { return; }
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, dpr = 1, stars = [], parts = [], running = true, visible = true, t0 = null;

    function size() {
      var r = cv.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(200, r.width); H = Math.max(200, r.height);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = [];
      for (var i = 0; i < 70; i++) {
        stars.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.2 + .2, p: Math.random() * 6.28 });
      }
    }

    function sep(time) {
      // cycle 14 s : ecart -> fusion -> ecart
      var c = (time % 14000) / 14000;
      var v;
      if (c < .55) { v = 1 - c / .55; }
      else if (c < .72) { v = 0; }
      else { v = (c - .72) / .28; }
      return .06 + .94 * (v * v * (3 - 2 * v));
    }

    function pos(time, k) {
      var s = sep(time);
      var a = time / 2600;
      var R = Math.min(W, H) * .27 * s;
      var x = W / 2 + k * R * Math.cos(a);
      var y = H * .5 + k * R * Math.sin(2 * a) * .45;
      return { x: x, y: y, s: s };
    }

    function emit(p, hue) {
      parts.push({ x: p.x + (Math.random() - .5) * 10, y: p.y, vx: (Math.random() - .5) * .5, vy: -(Math.random() * 1.3 + .9), life: 0, max: 46 + Math.random() * 30, r: Math.random() * 9 + 7, h: hue });
    }

    function drawInfinity(time) {
      var R = Math.min(W, H) * .27;
      ctx.save();
      ctx.strokeStyle = 'rgba(227,197,140,.16)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (var i = 0; i <= 120; i++) {
        var a = i / 120 * Math.PI * 2;
        var x = W / 2 + R * Math.cos(a);
        var y = H * .5 + R * Math.sin(2 * a) * .45;
        if (i === 0) { ctx.moveTo(x, y); } else { ctx.lineTo(x, y); }
      }
      ctx.stroke();
      ctx.restore();
    }

    function frame(time) {
      if (!t0) { t0 = time; }
      var tt = time - t0 + 3000;
      ctx.clearRect(0, 0, W, H);
      // halo central
      var g = ctx.createRadialGradient(W / 2, H * .5, 0, W / 2, H * .5, Math.min(W, H) * .5);
      g.addColorStop(0, 'rgba(156,125,232,.22)');
      g.addColorStop(1, 'rgba(11,8,32,0)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      // etoiles
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        var al = .35 + .35 * Math.sin(tt / 900 + st.p);
        ctx.fillStyle = 'rgba(239,233,248,' + al.toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(st.x, st.y, st.r, 0, 6.283); ctx.fill();
      }
      drawInfinity(tt);
      var A = pos(tt, -1), B = pos(tt, 1);
      if (!reduceMotion) {
        emit(A, 0); emit(A, 0); emit(B, 1); emit(B, 1);
      }
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j];
        p.life++;
        p.x += p.vx + Math.sin((p.life + p.y) / 9) * .35;
        p.y += p.vy;
        var k = p.life / p.max;
        if (k >= 1) { parts.splice(j, 1); continue; }
        var rr = p.r * (1 - k * .8);
        var gr = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, rr);
        if (p.h === 0) {
          gr.addColorStop(0, 'rgba(255,243,214,' + (.55 * (1 - k)).toFixed(3) + ')');
          gr.addColorStop(.45, 'rgba(227,197,140,' + (.38 * (1 - k)).toFixed(3) + ')');
        } else {
          gr.addColorStop(0, 'rgba(255,227,238,' + (.55 * (1 - k)).toFixed(3) + ')');
          gr.addColorStop(.45, 'rgba(230,144,173,' + (.38 * (1 - k)).toFixed(3) + ')');
        }
        gr.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = gr;
        ctx.beginPath(); ctx.arc(p.x, p.y, rr, 0, 6.283); ctx.fill();
      }
      // coeurs des flammes
      drawCore(A, 'rgba(255,240,205,', 'rgba(227,197,140,');
      drawCore(B, 'rgba(255,225,236,', 'rgba(230,144,173,');
      // eclat de fusion
      if (A.s < .12) {
        var f = 1 - (A.s - .06) / .06;
        if (f > 0) {
          var mg = ctx.createRadialGradient(W / 2, H * .5, 0, W / 2, H * .5, Math.min(W, H) * .3);
          mg.addColorStop(0, 'rgba(255,248,230,' + (.35 * f).toFixed(3) + ')');
          mg.addColorStop(1, 'rgba(255,248,230,0)');
          ctx.fillStyle = mg; ctx.fillRect(0, 0, W, H);
        }
      }
      ctx.restore();
      if (parts.length > 420) { parts.splice(0, parts.length - 420); }
      if (running && visible && !reduceMotion) { window.requestAnimationFrame(frame); }
    }

    function drawCore(p, c1, c2) {
      var r = Math.min(W, H) * .07;
      var gr = ctx.createRadialGradient(p.x, p.y - r * .2, 0, p.x, p.y, r);
      gr.addColorStop(0, c1 + '.95)');
      gr.addColorStop(.4, c2 + '.55)');
      gr.addColorStop(1, c2 + '0)');
      ctx.fillStyle = gr;
      ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, 6.283); ctx.fill();
    }

    size();
    window.addEventListener('resize', function () { size(); if (reduceMotion || !visible || !running) { var keep = visible; visible = false; frame(16); visible = keep; } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var was = visible;
        visible = en[0].isIntersecting;
        if (visible && !was && !reduceMotion) { window.requestAnimationFrame(frame); }
      }).observe(cv);
    }
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running && visible && !reduceMotion) { window.requestAnimationFrame(frame); }
    });
    if (reduceMotion) {
      for (var w = 0; w < 50; w++) { parts.push({ x: W / 2 + (w % 2 ? 40 : -40) + (Math.random() - .5) * 20, y: H * .5 - Math.random() * 60, vx: 0, vy: -1, life: Math.random() * 30, max: 60, r: 10, h: w % 2 }); }
      frame(16);
    } else {
      window.requestAnimationFrame(frame);
    }
  }

  /* ---------- Revelation au scroll ---------- */
  function initReveal(root) {
    root.className += ' fjx-js';
    var els = root.querySelectorAll('.fjx-rv');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      for (var i = 0; i < els.length; i++) { els[i].className += ' fjx-in'; }
      var pres = root.querySelectorAll('.fjx-g-pre');
      for (var q = 0; q < pres.length; q++) { pres[q].className = pres[q].className.replace(' fjx-g-pre', ''); }
      return;
    }
    var io = new IntersectionObserver(function (en) {
      for (var i = 0; i < en.length; i++) {
        if (en[i].isIntersecting) {
          var el = en[i].target;
          el.className += ' fjx-in';
          var g = el.querySelector ? el.querySelector('.fjx-g-pre') : null;
          if (g) { (function (gg) { setTimeout(function () { gg.className = gg.className.replace(' fjx-g-pre', ''); }, 150); })(g); }
          io.unobserve(el);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  /* ---------- Fil de la timeline ---------- */
  function initTimeline() {
    var tl = $('fjx-tl'), fill = $('fjx-tl-fill');
    if (!tl || !fill) { return; }
    var ticking = false;
    function upd() {
      ticking = false;
      var r = tl.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var p = (vh * .6 - r.top) / (r.height || 1);
      if (p < 0) { p = 0; } if (p > 1) { p = 1; }
      fill.style.transform = 'scaleY(' + p.toFixed(3) + ')';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- Horloge 24 heures ---------- */
  function initClock() {
    var box = $('fjx-clock');
    if (!box) { return; }
    var btns = [];
    for (var i = 0; i < 24; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fjx-hr' + (i === 11 ? ' fjx-on' : '');
      b.setAttribute('data-i', String(i));
      b.setAttribute('aria-label', HOURS[i][0] + ' flamme jumelle');
      b.textContent = HOURS[i][0];
      var a = (i / 24) * Math.PI * 2 - Math.PI / 2;
      b.style.left = (50 + 44 * Math.cos(a)).toFixed(2) + '%';
      b.style.top = (50 + 44 * Math.sin(a)).toFixed(2) + '%';
      b.addEventListener('click', onPick);
      box.appendChild(b);
      btns.push(b);
    }
    function onPick(e) {
      var idx = parseInt(e.currentTarget.getAttribute('data-i'), 10);
      for (var k = 0; k < btns.length; k++) { btns[k].className = 'fjx-hr' + (k === idx ? ' fjx-on' : ''); }
      var h = HOURS[idx][0];
      $('fjx-clock-big').textContent = h;
      $('fjx-clock-t').textContent = h + ' et flamme jumelle';
      $('fjx-clock-msg').textContent = HOURS[idx][1];
      var link = $('fjx-clock-a');
      link.setAttribute('href', '/pages/' + h + '-signification');
      link.textContent = 'Lire la signification compl\u00e8te de ' + h;
    }
  }

  /* ---------- Quiz ---------- */
  var quiz = { i: 0, answers: [], stage: 0, res: null };

  function renderQ() {
    var zone = $('fjx-q-zone');
    var Q = QUESTIONS[quiz.i];
    var h = '<div class="fjx-q-anim"><p class="fjx-q-title">' + esc(Q.q) + '</p><div class="fjx-opts">';
    for (var k = 0; k < Q.o.length; k++) {
      var picked = quiz.answers[quiz.i] === k ? ' fjx-picked' : '';
      h += '<button type="button" class="fjx-opt' + picked + '" data-k="' + k + '">' + esc(Q.o[k][0]) + '</button>';
    }
    h += '</div><div class="fjx-q-nav">';
    h += quiz.i > 0 ? '<button type="button" class="fjx-link-btn" id="fjx-q-back">Question pr\u00e9c\u00e9dente</button>' : '<span>&#8203;</span>';
    h += '<span>&#8203;</span></div></div>';
    zone.innerHTML = h;
    $('fjx-q-count').textContent = 'Question ' + (quiz.i + 1) + ' sur ' + QUESTIONS.length;
    $('fjx-prog').style.transform = 'scaleX(' + (quiz.i / QUESTIONS.length).toFixed(3) + ')';
    var opts = zone.querySelectorAll('.fjx-opt');
    for (var j = 0; j < opts.length; j++) { opts[j].addEventListener('click', onAnswer); }
    var back = $('fjx-q-back');
    if (back) { back.addEventListener('click', function () { quiz.i--; renderQ(); }); }
  }

  function onAnswer(e) {
    var k = parseInt(e.currentTarget.getAttribute('data-k'), 10);
    quiz.answers[quiz.i] = k;
    e.currentTarget.className += ' fjx-picked';
    setTimeout(function () {
      if (quiz.i < QUESTIONS.length - 1) { quiz.i++; renderQ(); }
      else { fetchResult(); }
    }, 260);
  }

  function renderWait() {
    $('fjx-q-count').textContent = 'Ton r\u00e9sultat';
    $('fjx-prog').style.transform = 'scaleX(1)';
    $('fjx-q-zone').innerHTML = '<div class="fjx-q-anim fjx-res-head"><p class="fjx-q-title">Les deux flammes se placent...</p><div class="fjx-res-gauge"><div class="fjx-gauge fjx-g-pre" style="--g:0"><span class="fjx-dot fjx-dot-a"></span><span class="fjx-dot fjx-dot-b"></span></div></div></div>';
  }

  function renderError(msg) {
    $('fjx-q-zone').innerHTML = '<div class="fjx-q-anim fjx-res-head"><p class="fjx-q-title">' + esc(msg) + '</p><div class="fjx-res-actions"><button type="button" class="fjx-btn" id="fjx-retry"><span class="fjx-btn-lbl">R\u00e9essayer</span></button><button type="button" class="fjx-link-btn" id="fjx-redo">Refaire le test</button></div></div>';
    $('fjx-retry').addEventListener('click', fetchResult);
    $('fjx-redo').addEventListener('click', function () { quiz.i = 0; quiz.answers = []; renderQ(); });
  }

  function fetchResult() {
    renderWait();
    api({ action: 'result', answers: quiz.answers }, function (d) {
      if (!d || !d.ok || !d.stage) { renderError('Le r\u00e9sultat n\u2019a pas pu \u00eatre calcul\u00e9. V\u00e9rifie ta connexion puis r\u00e9essaie.'); return; }
      if (d.tokenValid === false) { clearToken(); }
      quiz.stage = d.stage; quiz.res = d;
      renderResult();
    });
  }

  function detailHtml(D) {
    var h = '<h3>Ce qui se joue pour toi</h3><p>' + esc(D.play) + '</p>';
    h += '<h3>Que faire maintenant</h3><ul>';
    for (var i = 0; i < (D.tips || []).length; i++) { h += '<li>' + esc(D.tips[i]) + '</li>'; }
    h += '</ul><h3>Ta pierre alli\u00e9e</h3><p>' + esc(D.stone) + '</p>';
    h += '<h3>Ton heure miroir \u00e0 surveiller</h3><p>Pendant cette \u00e9tape, <a href="/pages/' + esc(D.hour) + '-signification">' + esc(D.hour) + '</a> porte un message particulier pour ta connexion.</p>';
    h += '<h3>Ton affirmation</h3><p class="fjx-affirm">\u00ab ' + esc(D.aff) + ' \u00bb</p>';
    return h;
  }

  function placeholderHtml() {
    var p = 'Ton analyse d\u00e9taill\u00e9e appara\u00eetra ici : ce qui se joue pour toi \u00e0 cette \u00e9tape, les gestes concrets \u00e0 poser, la pierre qui t\u2019accompagne et ton affirmation du moment.';
    return '<h3>Ce qui se joue pour toi</h3><p>' + p + '</p><h3>Que faire maintenant</h3><ul><li>' + p + '</li><li>' + p + '</li><li>' + p + '</li></ul><h3>Ta pierre alli\u00e9e</h3><p>' + p + '</p><h3>Ton affirmation</h3><p class="fjx-affirm">\u00ab \u2026 \u00bb</p>';
  }

  function renderResult() {
    var R = quiz.res;
    var un = !!(R.unlocked && R.detail);
    $('fjx-q-count').textContent = 'Ton r\u00e9sultat';
    $('fjx-prog').style.transform = 'scaleX(1)';
    var h = '<div class="fjx-q-anim">';
    h += '<div class="fjx-res-head"><span class="fjx-eyebrow">\u00c9tape ' + R.stage + ' sur 8</span>';
    h += '<p class="fjx-res-stage">' + esc(R.name) + '</p>';
    h += '<p class="fjx-res-sum">' + esc(R.sum) + '</p></div>';
    h += '<div class="fjx-res-gauge"><div class="fjx-gauge fjx-g-pre" id="fjx-res-g" style="--g:' + parseInt(R.g, 10) + '"><span class="fjx-dot fjx-dot-a"></span><span class="fjx-dot fjx-dot-b"></span></div><p class="fjx-gauge-lbl"><span>S\u00e9par\u00e9es</span><span>Unies</span></p></div>';
    h += '<div class="fjx-lock' + (un ? '' : ' fjx-locked') + '" id="fjx-lock"><div class="fjx-lock-in" id="fjx-lock-in">';
    h += un ? detailHtml(R.detail) : placeholderHtml();
    h += '</div><div class="fjx-lock-veil"><p>Ton analyse compl\u00e8te t\u2019attend : ce qui se joue, 3 gestes concrets, ta pierre alli\u00e9e et ton affirmation.</p><button type="button" class="fjx-btn" id="fjx-unlock"><span class="fjx-btn-lbl">D\u00e9bloquer mon analyse gratuite</span></button></div></div>';
    h += '<div class="fjx-res-actions"><button type="button" class="fjx-link-btn" id="fjx-redo">Refaire le test</button></div>';
    h += '</div>';
    $('fjx-q-zone').innerHTML = h;
    setTimeout(function () { var g = $('fjx-res-g'); if (g) { g.className = 'fjx-gauge'; } }, 120);
    var ub = $('fjx-unlock');
    if (ub) { ub.addEventListener('click', function () { openPop('quiz'); }); }
    $('fjx-redo').addEventListener('click', function () { quiz.i = 0; quiz.answers = []; quiz.res = null; renderQ(); });
  }

  function showDetail(D) {
    var lk = $('fjx-lock'), inn = $('fjx-lock-in');
    if (!lk || !inn) { return; }
    inn.innerHTML = detailHtml(D);
    lk.className = 'fjx-lock';
    lk.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function initQuiz() {
    if (!$('fjx-q-zone')) { return; }
    renderQ();
  }

  /* ---------- Popup + Klaviyo ---------- */
  var popMode = 'quiz';
  var pendingDetail = null;
  function isLive() { return /(^|\.)astroya\.fr$/i.test(window.location.hostname) || /myshopify\.com$/i.test(window.location.hostname); }

  function initPop() {
    var pop = $('fjx-pop');
    if (!pop) { return; }
    if (pop.parentNode !== document.body) { document.body.appendChild(pop); }
    $('fjxp-x').addEventListener('click', closePop);
    pop.addEventListener('click', function (e) { if (e.target === pop) { closePop(); } });
    document.addEventListener('keydown', function (e) { if (e.keyCode === 27 && pop.className.indexOf('fjx-pop-show') > -1) { closePop(); } });
    $('fjxp-form').addEventListener('submit', onSubmit);
    $('fjxp-done').addEventListener('click', function () {
      closePop();
      if (popMode === 'quiz' && pendingDetail) { showDetail(pendingDetail); pendingDetail = null; }
    });
    $('fjxp-email').addEventListener('change', function () { lsSet(EMAIL_KEY, $('fjxp-email').value || ''); });
    if (!isLive()) { $('fjxp-demo').hidden = false; }
    var nb = $('fjx-nl-btn');
    if (nb) {
      if (isUnlocked()) { setNlDone(); }
      nb.addEventListener('click', function () { openPop('nl'); });
    }
  }

  function setNlDone() {
    var t = $('fjx-nl-txt'), b = $('fjx-nl-btn');
    if (t) { t.textContent = 'Tu fais d\u00e9j\u00e0 partie de la communaut\u00e9 Astroya. Ta prochaine lettre arrive bient\u00f4t dans ta bo\u00eete mail.'; }
    if (b && b.className.indexOf('fjx-hide') < 0) { b.className += ' fjx-hide'; }
  }

  function openPop(mode) {
    popMode = mode;
    var pop = $('fjx-pop');
    $('fjxp-s1').className = 'fjxp-scr fjxp-cur';
    $('fjxp-s2').className = 'fjxp-scr';
    $('fjxp-err').innerHTML = '&#8203;';
    if (mode === 'quiz') {
      $('fjxp-eye').textContent = 'Analyse offerte';
      $('fjxp-t1').textContent = 'D\u00e9bloque ton analyse compl\u00e8te';
      $('fjxp-p1').textContent = "Ton \u00e9tape \u00ab " + (quiz.res ? quiz.res.name : '') + " \u00bb en d\u00e9tail, et chaque semaine la lettre Astroya : synchronicit\u00e9s, rituels et \u00e9nergies du moment.";
      $('fjxp-go').textContent = 'D\u00e9bloquer mon analyse';
      $('fjxp-done').textContent = 'Lire mon analyse';
      $('fjxp-p2').textContent = 'Ton analyse est d\u00e9bloqu\u00e9e. Tu recevras aussi la prochaine lettre Astroya dans ta bo\u00eete mail.';
    } else {
      $('fjxp-eye').textContent = 'La lettre Astroya';
      $('fjxp-t1').textContent = 'Rejoins la communaut\u00e9 Astroya';
      $('fjxp-p1').textContent = 'Synchronicit\u00e9s, lunaisons, rituels d\'amour et guidance des anges, chaque semaine dans ta bo\u00eete mail.';
      $('fjxp-go').textContent = 'Je m\'inscris';
      $('fjxp-done').textContent = 'Fermer';
      $('fjxp-p2').textContent = 'Merci ! Ta premi\u00e8re lettre Astroya arrive bient\u00f4t dans ta bo\u00eete mail.';
    }
    var saved = lsGet(EMAIL_KEY);
    if (saved && !$('fjxp-email').value) { $('fjxp-email').value = saved; }
    pop.className = 'fjx-pop-show';
    setTimeout(function () { try { $('fjxp-email').focus(); } catch (e) { } }, 60);
  }

  function closePop() { $('fjx-pop').className = ''; }

  function onSubmit(e) {
    e.preventDefault();
    var email = ($('fjxp-email').value || '').replace(/^\s+|\s+$/g, '');
    var err = $('fjxp-err');
    lsSet(EMAIL_KEY, email);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Indique une adresse email valide, par exemple prenom@exemple.fr.'; return; }
    if (!$('fjxp-ok').checked) { err.textContent = 'Coche la case pour accepter de recevoir la newsletter.'; return; }
    err.innerHTML = '&#8203;';
    var btn = $('fjxp-go');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Un instant...';
    api({ action: 'subscribe', email: email, consent: true, answers: popMode === 'quiz' ? quiz.answers : [] }, function (d) {
      btn.disabled = false; btn.textContent = label;
      if (d && d.ok && d.token) {
        setToken(d.token);
        setNlDone();
        if (popMode === 'quiz' && d.detail) { pendingDetail = d.detail; if (quiz.res) { quiz.res.unlocked = true; quiz.res.detail = d.detail; } }
        $('fjxp-s1').className = 'fjxp-scr';
        $('fjxp-s2').className = 'fjxp-scr fjxp-cur';
        try { $('fjxp-done').focus(); } catch (x) { }
      } else {
        err.textContent = (d && d.error) ? d.error : "L'inscription n'a pas pu aboutir. V\u00e9rifie ta connexion puis r\u00e9essaie.";
      }
    });
  }



  /* ---------- 12 signes : cartes a cocher ---------- */
  function initSigns() {
    var list = $('fjx-signs');
    if (!list) { return; }
    var cards = list.querySelectorAll('.fjx-sign');
    var n = 0;
    var MSG = [
      [0, "Coche les signes que tu reconnais dans ta relation."],
      [1, "Un premier \u00e9cho. Continue : c'est l'accumulation qui parle."],
      [4, "Quelques signes forts. Ce lien a quelque chose de particulier."],
      [7, "Beaucoup de signes r\u00e9unis. Une connexion d'\u00e2me est probable."],
      [10, "Presque tous les signes. Le test des 8 \u00e9tapes va te dire o\u00f9 tu en es."]
    ];
    function upd() {
      $('fjx-meter-n').textContent = String(n);
      $('fjx-meter-bar').style.transform = 'scaleX(' + (n / 12).toFixed(3) + ')';
      var t = MSG[0][1];
      for (var i = 0; i < MSG.length; i++) { if (n >= MSG[i][0]) { t = MSG[i][1]; } }
      $('fjx-meter-txt').textContent = t;
    }
    function toggle(e) {
      var c = e.currentTarget;
      var on = c.className.indexOf('fjx-checked') > -1;
      if (on) { c.className = c.className.replace(' fjx-checked', ''); n--; }
      else { c.className += ' fjx-checked'; n++; }
      c.setAttribute('aria-pressed', on ? 'false' : 'true');
      upd();
    }
    for (var k = 0; k < cards.length; k++) {
      cards[k].setAttribute('role', 'button');
      cards[k].setAttribute('tabindex', '0');
      cards[k].setAttribute('aria-pressed', 'false');
      cards[k].addEventListener('click', toggle);
      cards[k].addEventListener('keydown', function (e) { if (e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); toggle(e); } });
    }
    upd();
  }

  /* ---------- Compte a rebours prochaine heure miroir ---------- */
  var nextIdx = 11;
  function initNext() {
    var btn = $('fjx-next');
    if (!btn) { return; }
    function tick() {
      var d = new Date();
      var h = d.getHours(), m = d.getMinutes(), sec = d.getSeconds();
      var target = (m < h) ? h : (h + 1) % 24;
      var now = h * 3600 + m * 60 + sec;
      var tgt = target * 3600 + target * 60;
      if (tgt <= now) { tgt += 86400; }
      var left = tgt - now;
      var hh = Math.floor(left / 3600), mm = Math.floor((left % 3600) / 60), ss = left % 60;
      nextIdx = target;
      $('fjx-next-h').textContent = HOURS[target][0];
      $('fjx-next-in').textContent = (hh > 0 ? hh + 'h ' : '') + (mm < 10 ? '0' : '') + mm + 'min ' + (ss < 10 ? '0' : '') + ss + 's';
    }
    tick();
    setInterval(tick, 1000);
    btn.addEventListener('click', function () {
      var b = document.querySelector('#fjx-clock .fjx-hr[data-i="' + nextIdx + '"]');
      if (b) { b.click(); }
    });
  }

  /* ---------- Message du jour : 3 cartes ---------- */
  var CARDS = [
    ["Patience", "Ce qui est \u00e0 toi ne te d\u00e9passera pas. Laisse le temps faire son \u0153uvre entre vous."],
    ["Miroir", "Ce que tu reproches \u00e0 l'autre aujourd'hui te montre un endroit de toi \u00e0 consoler."],
    ["Portail", "Une synchronicit\u00e9 t'attend dans les 48 heures. Garde les yeux et le c\u0153ur ouverts."],
    ["L\u00e2cher-prise", "Cesse de tirer sur le fil. Le lien tient tout seul quand tu respires."],
    ["Retour", "Une nouvelle, un signe ou un message arrive bient\u00f4t. Ne le force pas."],
    ["Racines", "Ancre-toi : ta stabilit\u00e9 est le plus beau cadeau que tu puisses faire \u00e0 cette connexion."],
    ["Lumi\u00e8re", "Tu sors d'une zone d'ombre. Ce que tu as compris r\u00e9cemment va changer la suite."],
    ["Confiance", "Tu n'as rien \u00e0 prouver. Ta flamme te reconna\u00eet d\u00e9j\u00e0, m\u00eame en silence."],
    ["Silence", "Le silence de l'autre n'est pas un verdict. C'est son chemin qui se fait, loin de toi."],
    ["Gu\u00e9rison", "Prends soin de la blessure r\u00e9veill\u00e9e. C'est elle, et non l'autre, qui demande ton attention."],
    ["Union", "Une harmonie se pr\u00e9pare. Accueille-la sans l'analyser."],
    ["Intuition", "Tu connais d\u00e9j\u00e0 la r\u00e9ponse \u00e0 ta question. \u00c9coute ce que ton corps te dit."]
  ];
  function dayKey() { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function initDeck() {
    var deck = $('fjx-deck');
    if (!deck) { return; }
    var cards = deck.querySelectorAll('.fjx-card');
    var seed = 0, dk = dayKey();
    for (var i = 0; i < dk.length; i++) { seed = (seed * 31 + dk.charCodeAt(i)) % 100003; }
    var picks = [];
    for (var k = 0; k < 3; k++) { var idx = (seed + k * 7 + k * k * 3) % CARDS.length; while (picks.indexOf(idx) > -1) { idx = (idx + 1) % CARDS.length; } picks.push(idx); }
    var saved = lsGet('astroya_fj_card');
    var done = null;
    if (saved && saved.indexOf(dk + '|') === 0) { done = parseInt(saved.split('|')[1], 10); }
    function reveal(c, i, animate) {
      var card = CARDS[picks[i]];
      c.querySelector('.fjx-card-front b').textContent = card[0];
      c.querySelector('.fjx-card-front span').textContent = card[1];
      c.className += ' fjx-flip';
      c.setAttribute('aria-label', 'Carte ' + card[0] + ' : ' + card[1]);
      for (var j = 0; j < cards.length; j++) { if (j !== i) { cards[j].className += ' fjx-gone'; } }
      $('fjx-deck-note').textContent = 'Ton message du jour est tir\u00e9. Reviens demain pour un nouveau tirage.';
    }
    for (var m = 0; m < cards.length; m++) {
      (function (c, i) {
        if (done === i) { reveal(c, i, false); return; }
        if (done !== null) { c.className += ' fjx-gone'; return; }
        c.addEventListener('click', function () {
          if (c.className.indexOf('fjx-flip') > -1 || c.className.indexOf('fjx-gone') > -1) { return; }
          lsSet('astroya_fj_card', dk + '|' + i);
          reveal(c, i, true);
        });
      })(cards[m], m);
    }
  }

  /* ---------- Barre de lecture ---------- */
  function initReadBar() {
    if ($('fjx-read')) { return; }
    var bar = document.createElement('div');
    bar.id = 'fjx-read';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span></span>';
    document.body.appendChild(bar);
    var sp = bar.firstChild, root = $('fjx'), tk = false;
    function upd() {
      tk = false;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var total = r.height - vh;
      var p = total > 0 ? (-r.top) / total : 1;
      if (p < 0) { p = 0; } if (p > 1) { p = 1; }
      sp.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; window.requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- Demarrage ---------- */
  function boot() {
    if (window.__astroyaFjxBoot) { return true; }
    var root = $('fjx');
    if (!root || !$('fjx-q-zone')) { return false; }
    window.__astroyaFjxBoot = true;
    initReveal(root);
    initCanvas();
    initTimeline();
    initClock();
    initNext();
    initQuiz();
    initPop();
    initSigns();
    initDeck();
    initReadBar();
    return true;
  }

  var tries = 0;
  var iv = setInterval(function () { tries++; if (boot() || tries >= 40) { clearInterval(iv); } }, 120);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (boot()) { mo.disconnect(); } });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();
} catch(error){console.error(error);}